/** @format */
import React, { useEffect } from "react";
import { LoadingPage } from "components";
import { useUser } from "hooks";
import i18next from "i18next";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { privateRoutes, publicRoutes, RouterType } from "./routes";
import NotFound from "pages/404/Notfound";

const RequireAuth = () => {
  const { isLogged } = useUser();
  return isLogged ? <Outlet /> : <Navigate to="/login" />;
};

function App() {
  const { languages, mode } = useUser();

  useEffect(() => {
    if (languages.value) {
      i18next.changeLanguage(languages.value);
    }
  }, [languages.value]);

  useEffect(() => {
    const idApp = document.body;
    if (mode === "dark") {
      idApp.classList.add("dark");
      idApp.classList.remove("light");
    } else {
      idApp.classList.remove("dark");
      idApp.classList.add("light");
    }
  }, [mode]);

  return (
    <React.Suspense fallback={<LoadingPage />}>
      <Routes>
        <Route element={<RequireAuth />}>
          {privateRoutes.map((route: RouterType, index) => {
            const Layout = route.layout;
            const Component = route.component;
            return (
              <Route
                key={`${index}-${route.path}`}
                path={route.path}
                element={
                  <Layout>
                    <Component />
                  </Layout>
                }
              />
            );
          })}
        </Route>
        {publicRoutes.map((route: RouterType, index) => {
          const Layout = route.layout;
          const Component = route.component;
          return (
            <Route
              key={`${index}-${route.path}`}
              path={route.path}
              element={
                <Layout>
                  <Component />
                </Layout>
              }
            />
          );
        })}
        <Route path={"*"} element={<NotFound />} />
      </Routes>
    </React.Suspense>
  );
}

export default App;
